/**
 * Keeps the service worker fresh: checks for updates on focus and periodically,
 * and reloads once when a new worker takes control after a deploy.
 */

const SS_RELOAD_COOLDOWN_KEY = 'kissariti-sw-reload-at';
const RELOAD_COOLDOWN_MS = 30_000;

let reloadScheduled = false;

function reloadOnce(): void {
  if (reloadScheduled) return;

  const lastReload = sessionStorage.getItem(SS_RELOAD_COOLDOWN_KEY);
  if (lastReload && Date.now() - Number(lastReload) < RELOAD_COOLDOWN_MS) {
    return;
  }

  reloadScheduled = true;
  sessionStorage.setItem(SS_RELOAD_COOLDOWN_KEY, String(Date.now()));
  window.location.reload();
}

export function registerServiceWorkerLifecycle(): void {
  if (!('serviceWorker' in navigator)) return;
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return;

  let registration: ServiceWorkerRegistration | null = null;

  const checkForUpdates = () => {
    registration?.update().catch(() => {});
  };

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        registration = reg;

        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              navigator.serviceWorker.addEventListener('controllerchange', () => {
                reloadOnce();
              }, { once: true });
            }
          });
        });

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdates();
        });

        window.addEventListener('focus', checkForUpdates);

        setInterval(checkForUpdates, 45 * 60 * 1000);

        checkForUpdates();

        console.log('SW registered:', reg);
      })
      .catch((registrationError) => {
        console.log('SW registration failed:', registrationError);
      });
  });
}
